import React from 'react';
import {Box} from '@mui/material';
import {FieldInputProps, FieldMetaProps} from 'formik';
import {Pot} from '../../../schema-types/Pot';
import {contributeFieldType, contributeFromType} from './contributeFields';
import {getSummary} from '../CreateRecommend/RecommendSourceDestination/naming';
import {getValidation} from '../CreateRecommend/RecommendSourceDestination/validators';
import {ContributeSources} from './ContributeSources';
import {getCurrencyFloat} from '../../../utils/currencyFormatter';
import RecommendPlanForm from '../CreateRecommend/RecommendSourceDestination/RecommendPlanForm';

interface ContributeSourcePlanFormProps {
  pot: Pot;
  contributeFromPots: Pot[];
  contributeFieldObj: FieldInputProps<contributeFieldType | undefined>;
  contributeFromMeta: FieldMetaProps<contributeFromType | undefined>;
  contributeTo?: string;
  reviewId: string;
  handleChange: (event: React.ChangeEvent<any> | null, value: string) => void;
}

export const ContributeSourcePlanForm: React.FC<ContributeSourcePlanFormProps> = ({
  pot,
  contributeFromPots,
  contributeFieldObj,
  contributeFromMeta,
  contributeTo,
  reviewId,
  handleChange,
}) => {
  return (
    <RecommendPlanForm
      id={pot.id}
      reccId={pot.originalOvrId ?? null}
      summary={getSummary(pot, contributeTo)}
      greyed={pot.id === contributeTo}
      validation={
        contributeFieldObj.value?.contributeFrom?.id === pot.id
          ? getValidation(contributeFromMeta)
          : undefined
      }
      details={
        <ContributeSources id={pot.id} maxAmount={getCurrencyFloat(pot.totalValue)} />
      }
      curoId={pot.curoId}
      sameReview={pot.review?.id === reviewId}
      isSelected={contributeFieldObj.value?.contributeFrom?.id === pot.id}
      isSubplan={false}
      handleChange={handleChange}
    />
  );
};
